import { Box } from '@alf/uikit';
import useLiveEventState from '../../hooks/useLiveEventState';
import { useEventField } from '../../store';
import EventLabel from '../EventLabel';
import EventTime from '../EventTime';
import EventStateTimer from './components/EventStateTimer';

import styles from './index.module.css';

const EventState = ({
  eventHeadContainerClass = '',
  lineView,
  eventId,
  canceled = false,
  finished = false,
  inprogress = false
}) => {
  const { eventResultName } = useEventField(eventId, 'eventResultName');
  const { emptyStateText, labelText } = useLiveEventState(eventId);

  return (
    <Box
      data-role={`event-${eventId}-date-time`}
      className={eventHeadContainerClass}
    >
      <EventStateTimer
        eventId={eventId}
        emptyStateText={emptyStateText}
        lineView={lineView}
      />
      {finished || inprogress || canceled ? (
        <EventTime
          dataRole={`event-${eventId}-time`}
          eventId={eventId}
          lineView={lineView}
        />
      ) : (
        <EventLabel
          text={labelText || eventResultName}
          dataRole={`event-${eventId}-label`}
          className={`${styles.time} ${lineView ? styles[lineView] : ''}`}
        />
      )}
    </Box>
  );
};

export default EventState;
